import { PAGE_NAME } from '../../constants';

export const pageContext = {
    sourcePage: PAGE_NAME,
    currentPage: PAGE_NAME,
    viewportType: 'collections.show',
    controllerAction: 'collections#show',
};
